import { apiClient, unwrapApi } from './http';

/**
 * Jobs API — /jobs/*
 */
export async function getJobs(params = {}) {
  const { data } = await apiClient.get('/jobs', { params });
  return unwrapApi(data);
}

export async function getJob(id) {
  const { data } = await apiClient.get(`/jobs/${id}`);
  return unwrapApi(data);
}

export async function createJob(formData) {
  const { data } = await apiClient.post('/jobs', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return unwrapApi(data);
}

export async function updateJob(id, payload) {
  const { data } = await apiClient.put(`/jobs/${id}`, payload);
  return unwrapApi(data);
}

export async function updateJobStatus(id, body) {
  const { data } = await apiClient.put(`/jobs/${id}/status`, body);
  return unwrapApi(data);
}

export async function deleteJob(id) {
  const { data } = await apiClient.delete(`/jobs/${id}`);
  return unwrapApi(data);
}

export async function checkStock(lineItems) {
  const { data } = await apiClient.post('/jobs/check-stock', { lineItems });
  return unwrapApi(data);
}

export async function getJobStatsOverview() {
  const { data } = await apiClient.get('/jobs/stats/overview');
  return unwrapApi(data);
}

const jobsService = {
  getJobs,
  getJob,
  createJob,
  updateJob,
  updateJobStatus,
  deleteJob,
  checkStock,
  getJobStatsOverview,
};

export default jobsService;
